// import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import * as yup from "yup";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { createEbrouchers, getEbroucher, resetState, updateEbroucher } from "../features/EbrouchersSlice";
// import { toast } from "react-toastify";
// let schema = yup.object().shape({
// });

// const AddEbrouchers = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const getNewsId = location.pathname.split("/")[3];
//   const NewsState = useSelector((state) => state.Ebroucher);
//   const { isSuccess, isError, isLoading, createdEbroucher, EbroucherName, EbrouchershortName, Ebroucheremail, EbroucherPassword, Ebrouchertype, updatedEbroucher } = NewsState;
//   const [image, setImage] = useState(null);
//   const [imageError, setImageError] = useState("");


//   useEffect(() => {
//     if (getNewsId !== undefined) {
//       dispatch(getEbroucher(getNewsId));
//     } else {
//       dispatch(resetState());
//     }
//   }, [getNewsId]);

//   useEffect(() => {
//     dispatch(resetState());

//   }, []);

//   useEffect(() => {
//     if (isSuccess && createdEbroucher) {
//       toast.success("Ebroucher Added Successfully!");
//       dispatch(resetState());
//     }
//     if (isSuccess && updatedEbroucher) {
//       toast.success("Ebroucher Updated Successfully!");
//       navigate("/admin/Ebroucher-list");
//     }
//     if (isError) {
//       toast.error("Something Went Wrong!");
//     }
//   }, [isSuccess, isError, isLoading]);

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: {

//       name: EbroucherName || "",
//       shortName: EbrouchershortName || "",
//       type: Ebrouchertype || "",
//       email: Ebroucheremail || "",
//       password: EbroucherPassword || ""

//     },
//     validationSchema: schema,
//     onSubmit: (values) => {
//       if (!image) {
//         setImageError("Please select an image.");
//         return;
//       } else {
//         setImageError("");
//       }

//       const formData = new FormData();

//       formData.append("name", values.name);
//       formData.append("shortName", values.shortName);
//       formData.append("type", values.type);
//       formData.append("email", values.email);
//       formData.append("password", values.password);
//       formData.append("image", image);

//       if (getNewsId !== undefined) {
//         const data = { id: getNewsId, NewsData: formData };
//         dispatch(updateEbroucher(data));
//         dispatch(resetState());
//       } else {
//         dispatch(createEbrouchers(formData));
//         formik.resetForm();
//         setTimeout(() => {
//           dispatch(resetState());
//         }, 300);
//       }
//     },
//   });



//   return (
//     <div>
//       <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Ebroucher</h3>

//       <div className="">
//         <form action="" onSubmit={formik.handleSubmit}>
//           <div className="mt-4">
//             <label htmlFor="image" className="form-label">
//               Select Logo
//             </label>
//             <input
//               type="file"
//               id="image"
//               name="image"
//               accept="image/*"
//               onChange={(e) => {
//                 setImage(e.target.files[0]);
//                 setImageError("");
//               }}
//               className="form-control"
//             />
//             <div className="error">{imageError}</div>
//           </div>



//           <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
//             {getNewsId !== undefined ? "Edit" : "Add"} Ebroucher
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddEbrouchers;


// import React, { useState, useEffect } from "react";
// import { useFormik } from "formik";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// // import { addPdf, resetState } from "../features/pdf/pdfSlice";
// import { createEbrouchers, getEbroucher, resetState, updateEbroucher } from "../features/EbrouchersSlice";
// import { toast } from "react-toastify";

// const AddEbrouchers = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const id = location.pathname.split("/")[3];

//   const { isLoading, isSuccess, isError, message } = useSelector(
//     (state) => state.ebrouchers
//   );

//   const [pdfFiles, setPdfFiles] = useState([]);
//   const [thumbnail, setThumbnail] = useState(null);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (isSuccess) {
//       toast.success("PDF Uploaded Successfully");
//       dispatch(resetState());
//     }
//     if (isError) {
//       toast.error(message || "Upload Failed");
//       dispatch(resetState());
//     }
//   }, [isSuccess, isError]);

//   const formik = useFormik({
//     initialValues: {
//       name: "",
//       description: "",
//     },
//     onSubmit: (values, { resetForm }) => {
//       if (pdfFiles.length === 0) {
//         setError("Please upload at least one PDF");
//         return;
//       }

//       const formData = new FormData();

//       formData.append("name", values.name);
//       formData.append("description", values.description);

//       pdfFiles.forEach((file) => {
//         formData.append("image", file);
//       });

//       if (thumbnail) {
//         formData.append("thumbnail", thumbnail);
//       }

//       dispatch(createEbrouchers({ id, data: formData }));

//       resetForm();
//       setPdfFiles([]);
//       setThumbnail(null);
//       setError("");
//     },
//   });

//   return (
//     <div className="container mt-4">
//       <h3 className="mb-3">Upload PDF</h3>

//       <form onSubmit={formik.handleSubmit}>
//         {/* Name */}
//         <div className="mb-3">
//           <label>Name</label>
//           <input
//             type="text"
//             name="name"
//             className="form-control"
//             value={formik.values.name}
//             onChange={formik.handleChange}
//             required
//           />
//         </div>

//         {/* Description */}
//         <div className="mb-3">
//           <label>Description</label>
//           <textarea
//             name="description"
//             className="form-control"
//             value={formik.values.description}
//             onChange={formik.handleChange}
//           />
//         </div>

//         {/* PDF Upload */}
//         <div className="mb-3">
//           <label>Upload PDFs</label>
//           <input
//             type="file"
//             accept="application/pdf"
//             multiple
//             className="form-control"
//             onChange={(e) => {
//               setPdfFiles(Array.from(e.target.files));
//               setError("");
//             }}
//           />
//         </div>

//         {/* Preview PDFs */}
//         {pdfFiles.length > 0 && (
//           <div className="mb-3">
//             <p>Selected PDFs:</p>
//             <ul>
//               {pdfFiles.map((file, index) => (
//                 <li key={index}>{file.name}</li>
//               ))}
//             </ul>
//           </div>
//         )}

//         {/* Thumbnail */}
//         <div className="mb-3">
//           <label>Thumbnail</label>
//           <input
//             type="file"
//             accept="image/*"
//             className="form-control"
//             onChange={(e) => setThumbnail(e.target.files[0])}
//           />
//         </div>

//         {/* Thumbnail Preview */}
//         {thumbnail && (
//           <div className="mb-3">
//             <img
//               src={URL.createObjectURL(thumbnail)}
//               alt="thumbnail"
//               width="120"
//             />
//           </div>
//         )}

//         {/* Error */}
//         {error && <p className="text-danger">{error}</p>}

//         <button className="btn btn-success" type="submit">
//           {isLoading ? "Uploading..." : "Upload PDF"}
//         </button>
//       </form>
//     </div>
//   );
// };

// export default AddEbrouchers;


import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  createEbrouchers,
  getEbroucher,
  resetState,
  updateEbroucher,
} from "../features/EbrouchersSlice";
import { toast } from "react-toastify";

let schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  description: yup.string().required("Description is required"),
});

const AddEbrouchers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];

  const NewsState = useSelector((state) => state.Ebroucher);
  const {
    isSuccess,
    isError,
    createdEbroucher,
    updatedEbroucher,
    EbroucherName,
    EbroucherDescription,
  } = NewsState;

  const [image, setImage] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);

  const [imageError, setImageError] = useState("");
  const [thumbnailError, setThumbnailError] = useState("");

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getEbroucher(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsId, dispatch]);

  useEffect(() => {
    if (isSuccess && createdEbroucher) {
      toast.success("Ebroucher Added Successfully!");
      dispatch(resetState());
    }

    if (isSuccess && updatedEbroucher) {
      toast.success("Ebroucher Updated Successfully!");
      navigate("/admin/Ebroucher-list");
    }

    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, createdEbroucher, updatedEbroucher, dispatch, navigate]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: EbroucherName || "",
      description: EbroucherDescription || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      let valid = true;

      if (!image) {
        setImageError("Image is required");
        valid = false;
      } else {
        setImageError("");
      }

      if (!thumbnail) {
        setThumbnailError("Thumbnail is required");
        valid = false;
      } else {
        setThumbnailError("");
      }

      if (!valid) return;

      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("description", values.description);
      formData.append("image", image);
      formData.append("thumbnail ", thumbnail);

      if (getNewsId !== undefined) {
        dispatch(updateEbroucher({ id: getNewsId, NewsData: formData }));
      } else {
        dispatch(createEbrouchers(formData));
        formik.resetForm();
        setImage(null);
        setThumbnail(null);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">
        {getNewsId !== undefined ? "Edit" : "Add"} Ebroucher
      </h3>

      <form onSubmit={formik.handleSubmit}>

        {/* NAME */}
        <div className="mt-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={formik.values.name}
            onChange={formik.handleChange}
          />
          <div className="error">{formik.touched.name && formik.errors.name}</div>
        </div>

        {/* DESCRIPTION */}
        <div className="mt-3">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            className="form-control"
            value={formik.values.description}
            onChange={formik.handleChange}
          />
          <div className="error">
            {formik.touched.description && formik.errors.description}
          </div>
        </div>

        {/* IMAGE */}
        <div className="mt-3">
          <label className="form-label">Upload Image</label>
          <input
            type="file"
            className="form-control"
            accept="*"
            onChange={(e) => {
              setImage(e.target.files[0]);
              setImageError("");
            }}
          />
          <div className="error">{imageError}</div>
        </div>

        {/* THUMBNAIL */}
        <div className="mt-3">
          <label className="form-label">Upload Thumbnail</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={(e) => {
              setThumbnail(e.target.files[0]);
              setThumbnailError("");
            }}
          />
          <div className="error">{thumbnailError}</div>
        </div>

        <button
          className="btn btn-success border-0 rounded-3 my-4"
          type="submit"
        >
          {getNewsId !== undefined ? "Update" : "Add"} Ebroucher
        </button>
      </form>
    </div>
  );
};

export default AddEbrouchers;